export default __webpack_public_path__ + "static/media/1.a4f22360.png";